module.exports = __webpack_public_path__ + "static/media/ic_aprovar.b0a72656.svg";